<template>
  <VView class="contest-game" back-button-to="/menu" :header="$t('contestGame.header')">
    <VGame @end="onGameEnd($event)" />
  </VView>
</template>

<script>
import VGame from '@/games/vue-quiz/VGame.vue';
import { SET_ATTACHMENT, SET_SCORE } from '@/store';

export default {
  name: 'ContestGame',

  components: {
    VGame,
  },

  methods: {
    onGameEnd({ attachment, score }) {
      this.$store.commit(SET_ATTACHMENT, { attachment });
      this.$store.commit(SET_SCORE, { score });

      this.$router.push('/contest/question');
    },
  },
};
</script>

<style lang="scss" scoped>
.contest-game {}
</style>
